/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import Calculator from "./Calculator.container";

export default Calculator;
